import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { urlFor } from '../sanity/sanityClient';

const SearchForm = ({ searchResults }) => {
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 768px)").matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");

    const handleChange = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener("change", handleChange);

    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        padding: '10px 0',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '1200px',
        }}
      >
        {searchResults.length > 0 ? (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: isMobile
                ? 'repeat(2, 1fr)'   // 📱 mobile
                : 'repeat(5, 1fr)',  // 💻 desktop
              gap: '10px',
              padding: '10px',
            }}
          >
            {searchResults.map((result) => (
              <Link
                key={result._id}
                to={`/category/${result.slug.current}`}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div
                  style={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '12px',
                    boxShadow: '0 3px 10px rgba(0,0,0,0.1)',
                    transition: 'all 0.25s ease',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow =
                      '0 8px 18px rgba(0,0,0,0.18)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow =
                      '0 3px 10px rgba(0,0,0,0.1)';
                  }}
                >
                  {/* Image */}
                  <div
                    style={{
                      width: '100%',
                      height: isMobile ? '140px' : '160px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '8px',
                    }}
                  >
                    {result.image?.[0] && (
                      <img
                        src={urlFor(result.image[0])}
                        alt={result.name}
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                          borderRadius: '8px',
                        }}
                      />
                    )}
                  </div>

                  {/* Name */}
                  <p
                    style={{
                      fontSize: isMobile ? '13px' : '14px',
                      fontWeight: '600',
                      color: '#111',
                      margin: '6px 0',
                      lineHeight: '1.3',
                      minHeight: '36px',
                    }}
                  >
                    {result.name}
                  </p>

                  {/* Price */}
                  <p
                    style={{
                      fontSize: isMobile ? '14px' : '15px',
                      fontWeight: 'bold',
                      color: '#111',
                      marginTop: 'auto',
                    }}
                  >
                    {result.currency || 'TZS'}: {result.price?.toLocaleString()}/=
                  </p>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div
            style={{
              textAlign: 'center',
              padding: '20px',
              fontSize: '16px',
              color: '#555',
            }}
          >
            No results found!
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchForm;